import { render, h } from "preact";
import MuxReactSimple from "../components/MuxReactSimple.js";

const muxVideos = document.querySelectorAll("[data-mux-simple]");

muxVideos.forEach((container) => {
  const muxOptions = {
    poster: container.dataset.poster,
    playbackId: container.dataset.videoId,
    className: container.dataset.classes,
    preload: container.dataset.preload,
    loading: container.dataset.loading ? container.dataset.loading : "viewport",
  };
  if (container.dataset.autoplay == "true") {
    muxOptions.autoPlay = container.dataset.autoplay;
  }
  render(h(MuxReactSimple, muxOptions), container);
});
